import * as yup from "yup";
import {
  GenerateOn,
  ToneOfVoice,
} from "@towersystems/roam-common/lib/generated-types";

export const defaultFormValues = {
  productName: "",
  productFeaturesAndTags: "",
  categoryId: "",
  departmentId: "",
  toneOfVoice: "PROFESSIONAL",
  numberOfSentences: undefined,
  generateOn: [GenerateOn.PRODUCT_FEATURES_AND_TAGS, GenerateOn.PRODUCT_NAME],
  existingDescription: "",
};

const commaSeparatedValidator = (value: any) => {
  if (!value) return true;
  const arr = value
    .split(",")
    .map((s: string) => s.trim())
    .filter(Boolean);
  return arr.length > 0;
};

export const schema = yup.object().shape({
  productName: yup.string().required("Product name is required"),
  productFeaturesAndTags: yup
    .string()
    .test(
      "valid-if-present",
      "Please provide valid comma-separated values",
      commaSeparatedValidator
    ),
  category: yup.string(),
  department: yup.string(),
  toneOfVoice: yup.mixed<ToneOfVoice>().oneOf(Object.values(ToneOfVoice)),
  numberOfSentences: yup.number().min(1, "At least 1 sentence").nullable(),
  generateOn: yup.array().of(yup.string()),
});
